export const queryKeys = {
  courses: {
    allPublic: () => ["courses", "all", "public"],
    allAuthed: () => ["courses", "all", "authed"],
    my: () => ["courses", "my"],
    managed: () => ["courses", "managed"],
    admin: () => ["courses", "admin"],
  },
  course: {
    byId: (id) => ["course", "id", String(id ?? "")],
    bySlug: (slug) => ["course", "slug", String(slug ?? "")],
    topicsWithContent: (courseId) => ["course", String(courseId ?? ""), "content"],
    students: (courseId) => ["course", String(courseId ?? ""), "students"],
    studentsPage: (courseId, page, pageSize) => [
      "course",
      String(courseId ?? ""),
      "students",
      "page",
      Number(page ?? 1),
      "pageSize",
      Number(pageSize ?? 10),
    ],
    studentsEnrolledIds: (courseId) => [
      "course",
      String(courseId ?? ""),
      "students",
      "enrolledIds",
    ],
    completedStudents: (courseId) => ["course", String(courseId ?? ""), "completedStudents"],
    pathways: (courseId) => ["course", String(courseId ?? ""), "pathways"],
    instructors: (courseId) => ["course", String(courseId ?? ""), "instructors"],
    reviews: (courseId) => ["course", String(courseId ?? ""), "reviews"],
  },
};
